import localforage from 'localforage'

let localforageStoreModes = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'modes'
})

const initialState = {
  all: [],
  mode: []
}

let state = initialState

const getters = {
  getAllModes: state => state.all,
  getMode: state => state.mode
}

const actions = {
  importModes ({ commit }, modes) {
    return new Promise((resolve, reject) => {
      commit('clearModesState')
      modes.forEach((mode) => {
        localforageStoreModes.setItem(String(mode.id).trim(), JSON.stringify(mode)) // attention: modeway id is delivered as a string by the api
      })
      commit('setModesToState', modes)
      resolve()
    })
  },
  loadAllModes ({ commit }) {
    return new Promise((resolve, reject) => {
      let modes = []
      return localforageStoreModes.iterate(function (value, key, iterationNumber) {
        modes.push(JSON.parse(value))
      }).then(function () {
        commit('setModesToState', modes)
        resolve()
      })
    })
  },
  clearModesStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreModes.clear().then(() => {
        commit('clearModesState')
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  setModesToState (state, modes) {
    state.all = modes
  },
  clearModesState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/modes.js